import { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import OpsIncidentGraph from '../ExecutiveDash/OpsIncidentGraph';
import OpsComplianceStats from '../ExecutiveDash/OpsComplianceStats';
import OpsSustainabilityStats from '../ExecutiveDash/OpsSustainabilityData';
import HexagonLoader from '@/components/HexagonLoader/HexagonLoader';
import '@/styles/ExecutiveDashStyles.scss';
import '@/styles/OperationsDashStyles.scss'
import RegionalPortfolioStats from './RegionalPortfolioStats';
import AssetServices from './AssetServices';
import UserAvatarSVG from '@/components/UserAvatarSVG'

const OperationsDashboard = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const screenWidth = useScreenWidth();
    const [period, setPeriod] = useState(null);
    const sessionExpired = false;
    const [initialLoading, setInitialLoading] = useState(true);

    // Utility to get current period as "yyyyMM"
    const getCurrentPeriod = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth()).padStart(2, '0');
        setPeriod(`${year}${month}`);
    };
    useEffect(() => {
        getCurrentPeriod(); 
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setInitialLoading(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    //Checks the width of the screen and set the height based on that
    const calculateGraphHeight = () => {
        if (screenWidth < 768) return 140;
        if (screenWidth < 1200) return 160;
        if (screenWidth < 1900) return 180;
        return 250; // For very large screens
    };

    const graphHeight = calculateGraphHeight();
    
    function useScreenWidth() {
        const [width, setWidth] = useState(window.innerWidth);

        useEffect(() => {
            const handleResize = () => setWidth(window.innerWidth);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return width;
    }

    return (
        <>
            {initialLoading ? (
                <HexagonLoader />
            ) : (
                    <div className="opsdashboard-root">
                        {sessionExpired ? (
                            <div className="error-message">
                                <p>Your session has expired. Please log in again.</p>
                                <button onClick={() => navigate('/')}>Go to Login</button>
                            </div>
                        ) : (
                            <>
                                <div>
                                    <h1 className="dashboard-greeting">
                                        <UserAvatarSVG />
                                        Hello {user.FirstName || user.firstName}
                                    </h1>
                                    <h3>Operations Dashboard</h3>
                                </div>
                                <div className="opsoperations-dashboard">
                                    <div className="opsdashboard-row opsdashboard-row--full">
                                        <RegionalPortfolioStats period={period} />
                                    </div>
                                    <div className="opsdashboard-row">
                                        <div className="opsdashboard-col">
                                            <OpsComplianceStats period={period} />
                                        </div>
                                        <div className="opsdashboard-col">
                                            <div className="opsdash">
                                                <AssetServices period={period} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="opsdashboard-row">
                                        <div className="opsdashboard-col">
                                            <OpsSustainabilityStats period={period} />
                                        </div>
                                        <div className="opsdashboard-col">
                                            <div className="opsgraph-box">
                                                <OpsIncidentGraph period={period} height={graphHeight} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
            )}
        </>
    );
}


export default OperationsDashboard;